import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetShowMetricsBannerParams {
  showMetricsBanner: boolean;
}

export class SetShowMetricsBannerRequest extends Request<SetShowMetricsBannerParams, IResult> {
  constructor(params: SetShowMetricsBannerParams) {
    super('setShowMetricsBanner', params);
  }
}
